export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

// common
export const getShortCodeToUrlApi = '/public/admin_auth/get_url';
export const checkUserNameAvailability = '/public/admin_auth/check_user_availability';
export const getStartedApi = '/public/admin_auth/get_started';
export const getCognitoUserNameApi = '/public/admin_auth/fetch_user';
export const fileUploadApi = '/private/files_tma/tenants/s3/image/upload';

// Auth
export const forgotPasswordApi = '/public/admin_auth/forgot_password';
export const resetPasswordApi = '/public/admin_auth/set_password';

// Apis for Admin
export const getAdminDataByUserNameApi = '/private/admin/users/check_username';
export const getOrganizationListApi = '/private/admin/organization/list';
export const getOrganizationOptionsApi = '/private/admin/organization/options';
export const addOrganizationApi = '/private/admin/organization/add';
export const updateOrganizationApi = '/private/admin/organization/update';
export const deleteOrganizationApi = '/private/admin/organization/delete';
export const updateOrganizationStatusApi = '/private/admin/organization/status';
export const resendOrganizationInvitationApi = '/private/admin/organization/resend_invitation_email';
export const getAdminPermissionGroupListApi = '/private/admin/permission_group/permission';
export const getAdminPermissionGroupOptionsApi = '/private/admin/permission_group/options';
export const getAdminPermissionListApi = '/private/admin/permission_group/permission_list';
export const getAdminOrgPermissionGroupListApi = '/private/admin/permission_group/organization_permissions';
export const getAdminOrgPermissionGroupOptionsApi = '/private/admin/permission_group/organization_options';
export const getAdminOrgPermissionListApi = '/private/admin/permission_group/organization_permission_list';
export const addAdminPermissionApi = '/private/admin/permission_group/permission';
export const deleteAdminPermissionApi = '/private/admin/permission_group/permission';
export const updateAdminPermissionApi = '/private/admin/permission_group/permission';
export const deleteAdminOrgPermissionApi = '/private/admin/permission_group/organization_permissions';
export const updateAdminOrgPermissionApi = '/private/admin/permission_group/organization_permissions';
export const addAdminOrgPermissionApi = '/private/admin/permission_group/organization_permissions';
export const addAdminStaffApi = '/private/admin/users/staffs';
export const getAdminStaffApi = '/private/admin/users/list';
export const getAdminStaffById = '/private/admin/users/get';
export const updateAdminStaffStatusApi = '/private/admin/users/status';
export const changePasswordApi = '/private/admin/users/reset_my_password';
export const orgStaffChangePasswordApi = '/private/organization/users/reset_my_password';
export const updateProfilePictureApi = '/private/admin/users/update_profile_picture';
export const updateOrgProfilePictureApi = '/private/organization/users/update_profile_picture';
export const updateAdminStaffEmailIdGetOtpApi = '/private/admin/users/request_email_change';
export const updateAdminStaffEmailIdApi = '/private/admin/users/confirm_email_change';

// Apis for Organization
export const getOrgDataByUserNameApi = '/private/organization/users/check_username';
export const checkDomainAvailabilityApi = '/private/organization/venue/check_domain_availability';
export const getOrgPermissionGroupListApi = '/private/organization/permission_group/permission';
export const getOrgPermissionListApi = '/private/organization/permission_group/permission_list';
export const addOrgPermissionApi = '/private/organization/permission_group/permission';
export const updateOrgPermissionApi = '/private/organization/permission_group/permission';
export const deleteOrgPermissionApi = '/private/organization/permission_group/permission';
export const getOrgStaffListApi = '/private/organization/users/list';
export const getOrgVenueListApi = '/private/organization/venue/list';
export const getOrgVenueOptionsApi = '/private/organization/venue/options';
export const addOrgStaffApi = '/private/organization/users/staffs';
export const getOrgStaffByIdApi = '/private/organization/users/get';
export const getPermissionGroupsForVenueApi = '/private/tenants/permission_group/permission';
export const updateOrgStaffStatusApi = '/private/organization/users/status';
export const updateOrgStaffEmailIdGetOtpApi = '/private/organization/users/request_email_change';
export const updateOrgStaffEmailIdApi = '/private/organization/users/confirm_email_change';
export const getOrgSettingsApi = '/private/admin/organization/get_organization_branding';
export const updateOrgSettingsApi = '/private/admin/organization/update_organization_branding';

// Apis for super admin (TMA) branding
export const getTmaBrandingApi = '/private/admin/tma/branding';
export const tmaBrandingLogoApi = '/private/admin/tma/branding/logo';
export const getPublicTmaBrandingApi = '/public/admin_auth/tma_branding';

// Apis for venue
export const addVenueApi = '/private/organization/venue/add';
export const getVenuePermissionGroupListApi = '/private/organization/venue/permission';
export const getVenuePermissionGroupOptionsApi = '/private/organization/venue/permission/options';
export const getVenuePermissionListApi = '/private/organization/venue/permission_list';
export const getVenueUsersListApi = '/private/organization/venue/staff/list';
export const getVenueDetailByIdApi = '/private/organization/venue/get';
export const updateVenueApi = '/private/organization/venue/update';
export const deleteVenueApi = '/private/organization/venue/delete';
export const updateVenueStatusApi = '/private/organization/venue/status';
export const addVenueUserApi = '/private/organization/venue/staff';
export const getJobRolesApi = '/private/tenants/job_roles/item';
export const getVenueUsersByIdApi = '/private/organization/venue/staff/get';
export const updateVenueUserStatusApi = '/private/organization/venue/staff/status';
export const getVenueMenuByIdApi = '/private/organization/venue/menu';
export const getVenueBrandingByIdApi = '/private/organization/venue/branding/get';
export const updateVenueBrandingApi = '/private/organization/venue/branding';
export const applyBrandingToVenuesApi = '/private/organization/venue/branding/apply_to_venues';
export const menuBulkCopyApi = '/private/organization/venue/menu/bulk_copy';
export const menuImportUploadsApi = '/private/organization/menu_import/uploads';
export const menuImportBatchesApi = '/private/organization/menu_import/batches';
export const menuImportQuotaApi = '/private/organization/menu_import/quota';
export const usersBulkCopyApi = '/private/organization/venue/staff/bulk_copy';
export const scheduleApi = '/private/tenants/schedule';
export const userRolesApi = '/private/tenants/job_roles/item';
export const usersApi = '/private/tenants/users/list';
export const venueStaffOptionsApi = '/private/organization/venue/staff/options';
export const getVenueCreationStatusApi = '/private/organization/venue/check-multiple-domain-status';

// Apis for permission
export const getPermissionListApi = '/private/admin/permission_group/permission_list';

// Apis for subscription features
export const getFeatureListApi = '/private/subscription/feature';
export const createFeatureApi = '/private/subscription/feature';
export const updateFeatureApi = '/private/subscription/feature';
export const syncFeaturesApi = '/private/subscription/sync-features';
export const getSourceListApi = '/private/subscription/source-list';

// Apis for subscription plans
export const getSubscriptionPlansApi = '/private/subscription/subscription-plan';
export const createSubscriptionPlanApi = '/private/subscription/subscription-plan';
export const updateSubscriptionPlanApi = '/private/subscription/subscription-plan';
export const deleteSubscriptionPlanApi = '/private/subscription/subscription-plan';
export const getFeatureListForPlansApi = '/private/subscription/feature';
export const getAddonPlansApi = '/private/subscription/addon';
export const createAddonPlanApi = '/private/subscription/addon';
export const updateAddonPlanApi = '/private/subscription/addon';
export const getAddonByIdApi = '/private/subscription/addon';
export const deleteAddonPlanApi = '/private/subscription/addon';
export const archiveAddonApi = '/private/subscription/archive-addon';
export const getOrgSubscriptionPlansApi = '/private/subscription/organization/plans';
export const getOrgInvoicesApi = '/private/subscription/organization/billing/invoices';
export const getOrgSubscriptionDetailsApi = '/private/subscription/organization/subscription';
export const getOrgSubscriptionInfoApi = '/private/subscription/organization/subscription-info';
export const createOrgSubscriptionApi = '/private/subscription/organization/checkout-subscription';
export const changeOrgSubscriptionApi = '/private/subscription/organization/subscription/update';
export const cancelOrgSubscriptionApi = '/private/subscription/organization/subscription/cancel';
export const getOrgSubscriptionPortalApi = '/private/subscription/organization/portal';
